import React from 'react'

export function NotFound(): React.JSX.Element {
  return (
    <div className="min-h-screen flex items-center justify-center p-4">
      <div className="max-w-md text-center">
        <img
          src="/landing-logo.svg"
          alt="Nail The Landing"
          className="h-10 w-auto mx-auto mb-8"
        />
        <h1 className="text-3xl sm:text-4xl font-bold text-foreground">404 — Page Not Found</h1>
        <p className="mt-2 text-sm text-muted-foreground">
          The page you're looking for doesn't exist or has been moved.
        </p>
      </div>
    </div>
  )
}
